<template>
    <div class="progress-bar" :style="progressBarStyle">
        <div class="progress" :style="{ width: `${value / max * 100}%` }" />
    </div>
</template>
<script>
export default {
    props: {
        max: {
            type: Number,
            default: 100,
        },
        value: {
            type: Number,
            default: 0,
        },
        defaultColor: {
            type: String,
            default: null,
        },
        progressColor: {
            type: String,
            default: null,
        },
    },

    computed: {
        /**
         * Gets the list of progress bar styles.
         *
         * @returns {object} Progress bar styles.
         */
        progressBarStyle() {
            return {
                '--progress-bar-default-color': this.defaultColor,
                '--progress-bar-progress-color': this.progressColor,
            };
        },
    },
};
</script>
<style scoped lang="scss">
    @import './ProgressBar.scss';
</style>
